export default function objectWrap(name) {
  return value => ({ [name]: value });
}
